/* hauer-learn-hub · abre e fecha as etapas do Learn (13/10/2026). Ver sections/hauer-learn-hub.liquid. */
(function () {
  'use strict';
  function init(root) {
    if (!root || root.dataset.hlhReady) return;
    root.dataset.hlhReady = '1';
    var rail = root.querySelector('.hlh-rail'), drawer = root.querySelector('.hlh-drawer');
    var panels = Array.prototype.slice.call(root.querySelectorAll('.hlh-p'));
    var btns = Array.prototype.slice.call(root.querySelectorAll('.hlh-st'));
    var cur = null;
    function setOpen(id) {
      btns.forEach(function (b) { b.setAttribute('aria-expanded', String(b.getAttribute('data-st') === id)); });
      panels.forEach(function (p) { p.classList.toggle('on', p.getAttribute('data-st') === id); });
      if (id) {
        var p = root.querySelector('.hlh-p.on');
        if (p) Array.prototype.forEach.call(p.querySelectorAll('img[data-src]'), function (im) { im.src = im.getAttribute('data-src'); im.removeAttribute('data-src'); });
        drawer.classList.add('open');
        var ab = root.querySelector('.hlh-st[aria-expanded="true"]');
        if (ab && ab.scrollIntoView) { try { ab.scrollIntoView({ inline: 'center', block: 'nearest' }); } catch (e) { /* noop */ } }
        var top = rail.getBoundingClientRect().top;
        if (top < 0 || top > window.innerHeight * 0.55) window.scrollTo({ top: window.scrollY + top - (window.innerWidth < 900 ? 64 : 84), behavior: 'smooth' });
      } else {
        drawer.classList.remove('open');
      }
      cur = id;
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { var id = b.getAttribute('data-st'); setOpen(cur === id ? null : id); }); });
    // mouse/foco em cima da etapa já baixa as imagens do painel dela (abre sem esperar a foto)
    function warm(b) {
      var p = root.querySelector('.hlh-p[data-st="' + b.getAttribute('data-st') + '"]');
      if (p) Array.prototype.forEach.call(p.querySelectorAll('img[data-src]'), function (im) { var i = new Image(); i.src = im.getAttribute('data-src'); });
    }
    btns.forEach(function (b) { b.addEventListener('pointerenter', function () { warm(b); }, { once: true }); b.addEventListener('focus', function () { warm(b); }, { once: true }); });
    var x = root.querySelector('.hlh-x');
    if (x) x.addEventListener('click', function () { setOpen(null); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && cur) setOpen(null); });
    // editor de temas: bloco selecionado abre a etapa dele
    root.addEventListener('shopify:block:select', function (e) { var b = e.target.closest && e.target.closest('.hlh-st'); if (b) setOpen(b.getAttribute('data-st')); });
  }
  function boot() { document.querySelectorAll('[data-hauer-learn-hub]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
